import { render, staticRenderFns } from "./OzOverlay.vue?vue&type=template&id=51e594fa&scoped=true&"
import script from "./OzOverlay.vue?vue&type=script&lang=ts&"
export * from "./OzOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./OzOverlay.vue?vue&type=style&index=0&id=51e594fa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e594fa",
  null
  
)

export default component.exports